
import Vue from "vue";
import filters from "@/filters";
import Component from "vue-class-component";
import { Action } from "vuex-class";
import toast from "@/functions/toast.function";
import { WHATSAPP_NUMBER } from "@/constants/portal.constant";
import { AxiosResponse } from "axios";
import $ from "jquery";
import { Watch } from "vue-property-decorator";
import { SalesToken } from "@/store/school/types";
import ModalRegistration from "@/components/landing/ModalRegistration.vue";

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return undefined;
}

@Component({ filters, components: { ModalRegistration } })
export default class RegisterSchool extends Vue {
  @Action("getSchoolTypes", { namespace: "admin" })
  getSchoolTypes: any;
  @Action("getCountry", { namespace: "admin" })
  getCountry: any;
  @Action("getProvince", { namespace: "admin" })
  getProvince: any;
  @Action("getCity", { namespace: "admin" })
  getCity: any;
  @Action("getSchoolRequestDetail", { namespace: "school" })
  getSchoolRequestDetail: any;
  @Action("schoolRequestRegisterFree", { namespace: "school" })
  schoolRequestRegisterFree: any;
  @Action("schoolRequestValidateToken", { namespace: "school" })
  schoolRequestValidateToken!: ServiceCall<
    Respon<SalesToken>,
    { sales_token: string }
  >;

  schoolTypes: Array<any> = [];
  countries: Array<any> = [];
  provinces: Array<any> = [];
  cities: Array<any> = [];
  schoolType: any = null;
  country: Record<string, any> | null = null;
  province: Record<string, any> | null = null;
  city: Record<string, any> | null = null;
  paymentProof: any = null;
  paymentProofPreview: any = null;
  name = "";
  address = "";
  subdomain = "";
  logo: Blob | null = null;
  logoPreview: string | null = null;
  email = "";
  phone = "";
  adminName = "";
  adminPosition = "";
  adminEmail = "";
  adminPhone = "";
  acceptTerms = false;
  subscription: Record<string, any> | null = null;
  price = 0;
  step = 1;
  domainAvailable = false;
  domainAvailableText = "";
  isNotAvailableSchool: boolean = false;
  imageCropper = false;
  whatsappNumber = WHATSAPP_NUMBER.replace("+62", "0");

  @Watch("logo")
  onTrigger() {
    if (this.logo) this.logoPreview = URL.createObjectURL(this.logo);
    else this.logoPreview = null;
  }

  created() {
    this.getSchoolTypes({
      success: (response: AxiosResponse) => {
        this.schoolTypes = response.data.data;
      },
    });
    this.getCountry({
      success: (response: AxiosResponse) => {
        this.countries = response.data.data;
        let indonesiaId = this.countries.find((country) => country.name === "Indonesia")?.id;
        this.getProvince({
          params: {
            country: indonesiaId,
          },
          success: (response: AxiosResponse) => {
            this.provinces = response.data.data;
          },
        });
      },
    });

    if (this.$route.query.code?.length === 6) {
      this.schoolRequestValidateToken({
        params: { sales_token: this.$route.query.code.toString() },
      });
    } else if(this.$route.query.code){
      this.getSchoolRequestDetail({
        params: {
          code: this.$route.query.code,
        },
        success: (response: AxiosResponse) => {
          let data = response.data.data;
          this.name = data.name;
          this.email = data.email;
          this.phone = data.phone;
          this.address = data.address;
          this.schoolType = data.school_type;
          this.country = data.city.province.country;
          this.province = data.city.province;
          this.city = data.city;
          this.subdomain = data.subdomain;
          this.logo = data.logo;
          this.adminName = data.admin_name;
          this.adminEmail = data.admin_email;
          this.adminPhone = data.admin_phone;
          this.subscription = data.latest_package.package;
          this.price = data.latest_package.price;
        },
        fail: () => {
          this.$router.push({ name: "landing" });
        },
      });
    }
  }

  goToTop() {
    $("html, body").animate({ scrollTop: 0 }, 500);
  }

  onCountryChange(data: any, callback: any = null) {
    if (data) {
      this.getProvince({
        params: {
          country: data.id,
        },
        success: (response: AxiosResponse) => {
          this.provinces = response.data.data;
          if (callback) callback();
        },
      });
    } else {
      this.province = null;
      this.provinces = [];
    }
    this.city = null;
    this.cities = [];
  }

  onProvinceChange(data: any, callback: any = null) {
    if (data) {
      this.getCity({
        params: {
          province: data.id,
        },
        success: (response: AxiosResponse) => {
          this.cities = response.data.data;
          if (callback) callback();
        },
      });
    } else {
      this.city = null;
      this.cities = [];
    }
  }

  onPaymentChange(event: any) {
    this.paymentProof = event.target.files[0];
    this.paymentProofPreview = URL.createObjectURL(this.paymentProof);
  }

  domainValidation(value: string) {
    return /[ `!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>\\/?~]/.test(value);
  }

  isEmail(value: string) {
    return /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/.test(value);
  }

  onlyNumber(event: any) {
    let keyCode = event.keyCode ? event.keyCode : event.which;
    if (keyCode !== 43) {
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
      }
    }
  }

  nextStep() {
    if (this.step === 1) {
      this.subdomain = this.subdomain?.toLowerCase();
      if (!this.acceptTerms) {
        toast.warning(
          "Silahkan baca dan setujui ketentuan penggunaan terlebih dahulu"
        );
        return;
      }
      if (!this.schoolType) {
        toast.warning("Pilih jenis sekolah");
        return;
      }
      if (!this.name) {
        toast.warning("Masukkan nama sekolah");
        return;
      }
      // if (!this.subdomain) {
      //   toast.warning("Masukkan domain website yang diinginkan");
      //   return;
      // } else if (this.subdomain.match(/[^a-zA-Z0-9]/gi)?.length) {
      //   // toast.warning("Masukkan domain website yang diinginkan");
      // }
      // if (this.domainValidation(this.subdomain)) {
      //   toast.warning("Nama domain tidak boleh mengandung spasi dan simbol");
      //   return;
      // }
      if (!this.logo) {
        toast.warning("Masukkan logo sekolah");
        return;
      } else {
        let file = this.logo;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function () {
          const width = img.width;
          const height = img.height;
          if (width < 200 && height < 200) {
            toast.warning(
              "Ukuran logo Sekolah/perguruan tinggi yang diperbolehkan minimal 200x200 px"
            );
            return;
          }
        };
        img.onerror = function () {
          toast.warning("File harus image");
          return;
        };
        img.src = _URL.createObjectURL(file);
      }
      if (!this.province?.id) {
        toast.warning("Provinsi harus dipilih");
        return;
      }
      if (!this.city?.id) {
        toast.warning("Kota harus dipilih");
        return;
      }
      if (!this.address) {
        toast.warning("Masukkan alamat Sekolah/perguruan tinggi");
        return;
      }
      if (!this.email) {
        toast.warning("Masukkan alamat e-mail Sekolah/perguruan tinggi");
        return;
      }
      if (!this.isEmail(this.email)) {
        toast.warning(
          "Masukkan format e-mail yang sesuai untuk login ke akun Sekolah/perguruan tinggi"
        );
        return;
      }
      if (!this.phone) {
        toast.warning("Masukkan nomor telepon Sekolah/perguruan tinggi");
        return;
      }
      if (
        this.phone.replace("+62", "0").length < 9 ||
        this.phone.replace("+62", "0").length > 13
      ) {
        toast.warning("Nomor kontak terdiri dari 9 hingga 13 nomor");
        return;
      }
      if (!this.adminName) {
        toast.warning("Masukkan nama Anda");
        return;
      }
      if (!this.adminEmail) {
        toast.warning(
          "Masukkan e-mail untuk login ke akun Sekolah/perguruan tinggi"
        );
        return;
      }
      if (!this.isEmail(this.adminEmail)) {
        toast.warning(
          "Masukkan format e-mail yang sesuai untuk login ke akun Sekolah/perguruan tinggi"
        );
        return;
      }
      if (!this.adminPhone) {
        toast.warning("Masukkan nomor  kontak");
        return;
      }
      if (
        this.adminPhone.replace("+62", "0").length < 9 ||
        this.adminPhone.replace("+62", "0").length > 13
      ) {
        toast.warning("Nomor kontak terdiri dari 9 hingga 13 nomor");
        return;
      }

      const formData = new FormData();
      formData.append("school_type_id", this.schoolType.id);
      formData.append("subdomain", this.subdomain);
      if (this.logo) formData.append("logo", this.logo);
      formData.append("address", this.address);
      formData.append("phone", this.phone);
      formData.append("admin_email", this.adminEmail);
      formData.append("name", this.name);
      formData.append("city_id", this.city?.id);
      formData.append("admin_name", this.adminName);
      formData.append("admin_phone", this.adminPhone);
      formData.append("admin_position", this.adminPosition);
      formData.append("email", this.email);
      // formData.append("sales_token", this.$route.params.code);
      // formData.append("school_package_id", xxxxxxxxx);
      // formData.append("payment_proof", this.paymentProof);
      this.schoolRequestRegisterFree({
        params: formData,
        success: () => {
          this.step = 2;
          this.goToTop();
        },
      });
    }
  }
  
  handleSubmitRegistration() {
    this.step = 2;
    this.goToTop();
  }
}
